"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TrainingInterface_1 = require("../../../../BusinessLogicLayer/TrainingInterface");
exports.default = (rate) => {
    switch (rate) {
        case 1:
            return TrainingInterface_1.ExerciseRate.EASY;
        case 5:
            return TrainingInterface_1.ExerciseRate.MEDIUM;
        case 10:
            return TrainingInterface_1.ExerciseRate.HARD;
        default:
            return null;
    }
};
//# sourceMappingURL=translateRating.js.map